// src/app/state/reducers/user.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { UserState, initialUserState, UserWrapper } from '../models/user.model';
import * as UserActions from '../actions/user.actions';
import { logout, clearUserData } from '../actions/auth.actions';

export const userReducer = createReducer<UserState>(
  initialUserState,
  on(UserActions.loadUserByIdSuccess, (state, { userId, userData }) => ({
    ...state,
    users: {
      ...state.users,
      [userId]: new UserWrapper(userData),
    },
    error: null,
  })),
  on(UserActions.loadUserByIdFailure, (state, { userId, error }) => ({
    ...state,
    error,
  })),
  on(UserActions.loadUsers, (state) => ({
    ...state,
    error: null,
  })),
  on(UserActions.loadUsersSuccess, (state, { users, total }) => ({
    ...state,
    userList: users as any[],
    total,
    error: null,
  })),
  on(UserActions.loadUsersFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(UserActions.updateUserSuccess, (state, { userId, userData }) => ({
    ...state,
    users: {
      ...state.users,
      [userId]: new UserWrapper(userData),
    },
    error: null,
  })),
  on(UserActions.updateUserFailure, (state, { userId, error }) => ({
    ...state,
    error,
  })),
  on(UserActions.deleteUserSuccess, (state, { userId }) => {
    const { [userId]: removed, ...rest } = state.users;
    return {
      ...state,
      users: rest,
      error: null,
    };
  }),
  on(UserActions.deleteUserFailure, (state, { userId, error }) => ({
    ...state,
    error,
  })),
  on(UserActions.loadUserByEmailSuccess, (state, { userData }) => {
    const user = userData as any;
    return {
      ...state,
      users: {
        ...state.users,
        [user.id]: new UserWrapper(userData),
      },
      error: null,
    };
  }),
  on(UserActions.loadUserByEmailFailure, (state, { email, error }) => ({
    ...state,
    error,
  })),
  on(logout, clearUserData, () => initialUserState),
);
